import styled, { createGlobalStyle } from "styled-components"

export const ProfilePicImage = styled.img<{ src: string, size: number }>`
    width: ${props => props.size}rem;
    height: ${props => props.size}rem;
    border-radius: 50%;
    border: 2px solid #F6E7C1;
    background-color: #ECC159;
`

export default createGlobalStyle`
    *{
        margin: 0;
        padding: 0;
        outline: 0;
        box-sizing: border-box;
        font-family: 'Open Sans', sans-serif; 
    }

    #root{
        margin:0 auto;
    }
    body{
        background-color: #3E3E3E;
        background-size: 40px 40px;
        background-image:
        linear-gradient(to right, #4E4E4E 1px, transparent 1px),
        linear-gradient(to bottom, #4E4E4E 1px, transparent 1px);
    }

    a{
        text-decoration: none;
        color: inherit;
        transition: 0.3s;
    }
    a:hover{
        color: #F4722B;
        transition: 0.3s;
    }

    .svg-inline--fa {
        transform: translateY(8%);
    }
 `